module.exports = __webpack_public_path__ + "img/fa51b2d.png";